// extracted by mini-css-extract-plugin
export var filterIncDec = "_dq-0";
export var leftBorder = "_dq-1";
export var rightBorder = "_dq-2";
export var stringInput = "_dq-3";